// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1B_JJ","buttons":"Footer_buttons__rqz9I"};